module.exports = __webpack_public_path__ + "static/media/prb-nutri-site-logo-identidade-visual-768x591.8fbece2c.jpg";